<template>
  <div>
    <Camaras v-if="!reproducirVideo" :parametros="parametros" :esEnVivo="esEnVivo"></Camaras>
    <PanelDeReproduccion v-else :parametros="parametros"></PanelDeReproduccion>
    <PanelDeAccionesCamaras :componentesDeCamaras="componentesDeCamaras" :parametros="parametros" v-on:EstadoReproductor="estadoVideo($event)"></PanelDeAccionesCamaras>
  </div>
</template>
<script>
  import Camaras from '../Comun/Camaras'
  import PanelDeReproduccion from '../Comun/PanelDeReproduccion'  
  import PanelDeAccionesCamaras from '../Comun/PanelDeAccionesCamaras'

  export default {
    components: {
      Camaras,
      PanelDeAccionesCamaras,
      PanelDeReproduccion,
      videos: true
    },
    props: {
      parametros: Object,
      componentesDeCamaras: {},
      reproducirVideo: Boolean,
      esEnVivo:{type: Boolean, default:false}
    },
    methods: {
    estadoVideo(datos){
      this.$emit("EstadoReproductor",{'Estatus': datos.Estatus});
      }
    },
    mounted() {
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/Reproductor.vue